import { useMutation } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { deleteInputLink } from '../index';
export const useDeleteInputLink = () => {
    const { setAction } = useActionLogger();
    return useMutation(deleteInputLink, {
        onSuccess: () => {
            setAction({
                type: 'success',
                message: 'Removing the input link was successful',
            });
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
